import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import {
    Badge,
    Box,
    Drawer,
    IconButton
} from '@mui/material';
import { ShoppingCartWithItems } from 'common-models';
import { FC, useEffect, useState } from 'react';
import PageIsLoading from 'src/components/PageIsLoading';
import { ShoppingCart } from 'src/lib/ShoppingCart';
import { useGetShoppingCartQuery } from '../../features/events/eventShopApiSlice';
import { selectVisitor } from '../../features/visitor/visitorSlice';
import { useAppSelector } from '../../state/hooks';
import MiniCartContent from './MiniCartContent';
// import { useGetShoppingCartQuery, useChangeProductQuantityMutation } from '../features/shop/shopApiSlice';

const MiniCart: FC<{}> = () => {
    //const [skipLoadingShoppingCart, setSkipLoadingShoppingCart] = useState(false);
    const visitor = useAppSelector(selectVisitor);
    const [drawerOpen, setDrawerOpen] = useState(false);

    const [dataIsLoaded, setDataIsLoaded] = useState(false);


    const { data = {} as ShoppingCartWithItems } = useGetShoppingCartQuery(
        [visitor.identifier, 'Open']);


    // useEffect(() => {
    //     if (visitor.identifier && visitor.identifier.length > 0) {
    //         setSkipLoadingShoppingCart(false);
    //     }
    // }, [visitor])

    useEffect(() => {
        setDataIsLoaded(visitor !== undefined && data !== undefined);
    }, [visitor, data])

    const handleOpenShoppingCart = () => {
        setDrawerOpen(true);
    };


    function hasCartAndItems(shoppingCart: ShoppingCartWithItems): boolean {
        const currentState = ShoppingCart.getCurrentCartState(shoppingCart);

        if (currentState !== 'Open') {
            return false;
        }

        return (shoppingCart?.items?.length > 0) === true;
    }

    const shoppingCartButton = () => {
        const productCount = hasCartAndItems(data)
            ? getTotalProductCount(data)
            : 0;

        return (
            <Badge
                badgeContent={productCount}
                color='secondary'
                sx={{ color: 'white' }}
            >
                <ShoppingCartIcon sx={{ color: 'white' }} />
            </Badge>
        );
    }

    function getTotalProductCount(input: ShoppingCartWithItems): number {
        return input.items
            .map(x => x.quantity)
            .reduce((a, b) => a + b);
    }

    if (!dataIsLoaded) {
        return <PageIsLoading />
    }

    return (
        <Box>
            <IconButton
                size="large"
                aria-label="shopping cart"
                aria-controls="menu-mini-shopping-cart"
                aria-haspopup="true"
                className='app-menu-item-icon'
                onClick={handleOpenShoppingCart}
                sx={{ color: 'white' }}
            >
                {shoppingCartButton()}
            </IconButton>
            <Drawer
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
                anchor='right'
                classes={{
                    paper: 'minicart-drawer-paper'
                }}
            >
                <MiniCartContent
                    cartWithItems={data}
                    visitor={visitor}
                    setDrawerOpen={setDrawerOpen} />
            </Drawer>
        </Box>
    )
}

export default MiniCart
